// extracted by mini-css-extract-plugin
export default {"mobileVert":"PRTabPanel_mobileVert__3RZoj","root":"PRTabPanel_root__6twYM"};